// Internal modules
import type { CountryCodes } from '@/generated/graphql';
import type { TermsMap } from './types';
import { getUserAgreementPath } from '@/lib/utils/terms';

export const BILLING_WITH_PURCHASE_FLOW_TO_CONTENT_KEY_MAP = {
  CHANNEL_INITIATED_BILLING: 'customerInitiated',
  CHANNEL_INITIATED_BILLING_SINGLE_AGREEMENT: 'customerInitiated',
  MERCHANT_INITIATED_BILLING: 'merchantInitiated',
  MERCHANT_INITIATED_SINGLE_BILLING: 'merchantInitiated',
};

export const ENTERPRISE_CONTENT_KEYS = [
  'eBayPolicyLinkText',
  'facebookp2pPrivacyStatementLinkText',
];

export const BILL_PAY_CONSENT = 'billPayConsent';

export const getTermsMap = ({
  locale,
  country,
}: {
  locale: string;
  country: CountryCodes;
}): TermsMap => ({
  backupPaymentPolicyLink: {
    contentKey: 'paypalPolicy',
    path: 'backupPayment',
  },
  ebayPolicyLink: {
    contentKey: 'eBayPolicyLinkText',
    path: `https://wmsapp.ebay.com/wmsapp/ppba?locale=${locale}&country_code=${country}&_https2httpredirect=false`,
  },
  fbPrivacyLink: {
    contentKey: 'facebookp2pPrivacyStatementLinkText',
    path: 'https://www.facebook.com/privacy/explanation',
  },
  overseasRemittance: {
    contentKey: 'overseasRemittance',
    path: 'webapps/mpp/corporate/overseas-remittance',
  },
  paypalLink: {
    contentKey: 'paypalLink',
    path: '/',
  },
  paypalPolicy: {
    contentKey: 'paypalPolicy',
    path: 'popup/about-payment-methods',
  },
  recurringPaymentsPolicyLink: {
    contentKey: 'paypalPolicy',
    path: 'webapps/mpp/ua/recurringpymts-full',
  },
  userAgreement: {
    contentKey: 'userAgreement',
    getDynamicPath: getUserAgreementPath,
  },
});
